export { Qrcode as default } from './Qrcode';
